import { Link } from 'react-router-dom';

export default function FeatureBanner() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        <Link
          to="/category/guoman"
          className="group relative h-40 md:h-48 rounded-lg overflow-hidden cursor-pointer"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Chinese%20animation%20donghua%20theme%2C%20traditional%20Chinese%20aesthetic%20with%20modern%20anime%20style%2C%20warm%20red%20and%20gold%20tones%2C%20elegant%20martial%20arts%20atmosphere%2C%20clean%20composition%2C%20horizontal%20banner&width=800&height=400&seq=banner-guoman&orientation=landscape"
            alt="国漫专区"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute bottom-4 left-4">
            <h3 className="text-base font-heading font-bold text-white whitespace-nowrap">国漫专区</h3>
            <p className="text-xs text-white/70 mt-1 whitespace-nowrap">精选国产优质动漫</p>
          </div>
        </Link>

        <Link
          to="/category/riman"
          className="group relative h-40 md:h-48 rounded-lg overflow-hidden cursor-pointer"
        >
          <img
            src="https://readdy.ai/api/search-image?query=Japanese%20anime%20theme%2C%20popular%20anime%20characters%2C%20vibrant%20colorful%20illustration%2C%20warm%20golden%20tone%2C%20clean%20composition%2C%20horizontal%20banner%20format&width=800&height=400&seq=banner-riman&orientation=landscape"
            alt="日漫专区"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute bottom-4 left-4">
            <h3 className="text-base font-heading font-bold text-white whitespace-nowrap">日漫专区</h3>
            <p className="text-xs text-white/70 mt-1 whitespace-nowrap">经典与热门日漫合集</p>
          </div>
        </Link>

        <Link
          to="/category/meiman"
          className="group relative h-40 md:h-48 rounded-lg overflow-hidden cursor-pointer"
        >
          <img
            src="https://readdy.ai/api/search-image?query=American%20animation%20superhero%20theme%2C%20comic%20book%20aesthetic%2C%20bold%20dynamic%20illustration%2C%20warm%20amber%20and%20red%20tones%2C%20clean%20composition%2C%20horizontal%20banner&width=800&height=400&seq=banner-meiman&orientation=landscape"
            alt="美漫专区"
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
          <div className="absolute bottom-4 left-4">
            <h3 className="text-base font-heading font-bold text-white whitespace-nowrap">美漫专区</h3>
            <p className="text-xs text-white/70 mt-1 whitespace-nowrap">超级英雄与科幻世界</p>
          </div>
        </Link>
      </div>
    </section>
  );
}